import React from "react";
import { Button, Image, Spin } from "antd";
import { DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import { FaRegEdit } from "react-icons/fa";
import { getImg } from "../../Api/getImg";

const ReportCard = ({ 
  row, 
  columns, 
  getTextFor, 
  getPhotoIdFor, 
  updatingCellId,
  onEditColumn,
  onDeleteColumn,
  onEditCell
}) => {
  return (
    <div className="rounded-2xl transition-shadow duration-300">
      <div className="gap-4 grid md:grid-cols-1">
        {columns.length > 0 ? (
          columns.map((col) => {
            const cellId = `${row.bookingId}-${col.id}`;
            const isUpdating = updatingCellId === cellId;
            const cellText = getTextFor(col.id, row.bookingId);
            const photoId = getPhotoIdFor(col.id, row.bookingId);
console.log('====================================');
console.log(cellText);
console.log('====================================');
            return (
              <div
                key={col.id}
                className={`min-h-[100px] rounded-xl m-1 border overflow-hidden transition-colors duration-300 ${
                  col.id % 2 === 0 ? 'bg-yellowCard border-yellowBorder' : 'bg-card border-primary'
                }`}
              >
                <div className="px-4 pt-2 flex justify-between items-center">
                  <h4 className="text-primary font-semibold text-base flex-1 pb-2 flex items-center gap-2 border-b-gray-300 border-b">
                    {col.title}
                  </h4>
                  <div className="flex gap-2">
                    <Button
                      type="text"
                      icon={<FaRegEdit className="text-primary" />}
                      onClick={() => onEditColumn(col)}
                      className="hover:bg-white/30"
                      size="small"
                    />
                    <Button
                      type="text"
                      icon={<DeleteOutlined className="text-primary" />}
                      onClick={() => onDeleteColumn(col.id)}
                      className="hover:bg-white/30"
                      size="small"
                    />
                  </div>
                </div>

                <div className={`p-4 pt-1 min-h-[90px] relative ${
                  col.id % 2 === 0 ? 'bg-yellowCard' : 'bg-card'
                }`}>
                  {isUpdating && (
                    <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10 rounded-b-xl">
                      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                    </div>
                  )}

                  <div className={`flex flex-col justify-between h-full min-h-[100px] ${
                    isUpdating ? 'opacity-50' : ''
                  }`}>
                    <div className="flex justify-between gap-3 mb-3">
                      {cellText ? (
                        <p className="text-sm text-gray-700 break-words flex-1 leading-relaxed">
                          {cellText}
                        </p>
                      ) : (
                        <p className="text-sm text-gray-400 italic">No notes added yet</p>
                      )}
                      {photoId && (
                        <Image
                          width={50}
                          height={50}
                          preview
                          className="rounded-lg shadow-sm flex-shrink-0"
                          style={{ objectFit: "cover" }}
                          src={getImg(photoId)}
                        />
                      )}
                    </div>

                    <div className="flex justify-end items-center mt-auto pt-2 border-t border-gray-100">
                      <Button
                        type="text"
                        icon={<FaRegEdit className="text-primary" />}
                        onClick={() => {
                          if (!isUpdating) {
                            onEditCell({
                              bookingId: row.bookingId,
                              columnId: col.id,
                              text: cellText,
                              photoFile: null,
                              removeImage: false,
                              photoId: photoId,
                            });
                          }
                        }}
                        disabled={isUpdating}
                        className="text-primary hover:bg-blue-50"
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="col-span-full text-center py-8 text-gray-500">
            <p className="mb-4">📝 No columns added yet</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportCard;